import "./WhatIDoOne.scss";

function WhatIDoTwo() {
  return (
    <div className="WhatIDoOne">
      <div className="body">
        
        <div className="right">
          <h2>Full Stack Development</h2>
          <div className="technoloy">
            <div className="item">
              <img src="assets/Html.png" alt="" />
              <p className="tech-title">Html</p>
            </div>
            <div className="item">
              <img src="assets/Scss.png" alt="" />
              <p className="tech-title">Scss</p>
            </div>
            <div className="item">
              <img src="assets/React-Native.png" alt="" />
              <p className="tech-title">React</p>
            </div>
            <div className="item">
              <img src="assets/Redux.png" alt="" />
              <p className="tech-title">Redux</p>
            </div>
            <div className="item">
              <img src="assets/GraphQL.png" alt="" />
              <p className="tech-title">GraphQl</p>
            </div>
            <div className="item">
              <img src="assets/Node.png" alt="" />
              <p className="tech-title">Node</p>
            </div>
            <div className="item">
              <img src="assets/Django.png" alt="" />
              <p className="tech-title">Django</p>
            </div>
            <div className="item">
              <img src="assets/MongoDB.jpeg" alt="" />
              <p className="tech-title">MongoDB</p>
            </div>
          </div>
          <div className="desc">
            <p>
              ⚡ Developed full-stack web applications which processed, analyzed, and rendered data visually.
            </p>
            <br />
            <p>
              ⚡ Planned, wrote, and debugged web applications and software with complete accuracy.
            </p>
            <br />
            <p>
              ⚡ Used various ideas from distributed computing, large-scale design, real-time data processing, data storage, ML, and AI to solve challenging dataset problems
            </p>
          </div>
        </div>
        <div className="left">
          <img src="assets/FullStack.svg" alt="" Android Vector Image />
        </div>
      </div>
    </div>
  );
}

export default WhatIDoTwo;
